<div class="linear-container__total-odds" *ngIf="isValidOdds; else zeroValue" [ngClass]="oddsChangeIndicator">
    <span [ngClass]="{ 'linear-container__total-odds--boosted': boostedOdds }" [@oldOddsAnimation]="boostedOdds ? formattedOdds(totalOdds) : null">{{
        formattedOdds(totalOdds)
    }}</span>
    <span class="linear-container__boosted-odds" *ngIf="boostedOdds" [@newOddsAnimation]="formattedOdds(boostedOdds)">{{
        formattedOdds(boostedOdds)
    }}</span>
</div>

<ng-template #zeroValue>
    <div class="linear-container-total-odds__zero-value">
        <span class="linear-container-total-odds__dash">-</span>
        <span class="linear-container-total-odds__dash">-</span>
    </div>
</ng-template>
